import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/unassigned-messages/")({
  head: () => ({
    meta: [{ title: "会话分配 · imiker CRM" }],
  })
});
